export default "__VITE_ASSET__5408a462__"